import React, { useState, useEffect } from "react";
import Parse from "parse";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Input,
  FormControl,
  FormErrorMessage,
} from "@chakra-ui/react";
import { Button } from "@chakra-ui/react";

export default function DeleteUserDialogComponent({ deleteUser }) {
  const [isOpen, setIsOpen] = React.useState(false);

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [ePassword, setEPassword] = useState(false);
  const [wrong, setWrong] = useState(false);

  const onClose = () => {
    setIsOpen(false);
  };

  const deleteCurrent = async () => {
    setEPassword(false);
    setWrong(false);
    if (password === confirmPassword) {
      const currentUser = Parse.User.current();
      const user = await Parse.User.logIn(
        currentUser.get("email"),
        password
      ).then(
        (myObject) => {
          deleteUser();
          setIsOpen(false);
        },
        (error) => {
          setEPassword(true);
        }
      );
    } else {
      setEPassword(true);
      setWrong(true);
    }
  };
  const cancelRef = React.useRef();

  return (
    <>
      <Button
        bg="white"
        color={"#0080FF"}
        fontFamily={"Sofia Pro"}
        borderRadius="20px"
        size="xs"
        py={4}
        px={6}
        onClick={() => setIsOpen(true)}
        marginTop="30px"
        marginBottom={"20px"}
        className="desacButton"
      >
        SUPPRIMER LE COMPTE
      </Button>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete User
            </AlertDialogHeader>

            <AlertDialogBody>
              Etes-vous sûr de vouloir désactiver votre compte ? Si c’est le
              cas, vous serez immédiatement déconnecté et votre compte ne seras
              plus accessible pour qui que ce soit.
            </AlertDialogBody>

            <Input
              pr="4.5rem"
              placeholder="Enter password"
              id="Password"
              value={password}
              type="password"
              bg="white"
              errorBorderColor="red.300"
              onChange={(e) => setPassword(e.target.value)}
            />

            <FormControl isInvalid={ePassword}>
              <Input
                pr="4.5rem"
                placeholder="Enter confirmation password"
                id="ConfirmPassword"
                type="password"
                value={confirmPassword}
                bg="white"
                errorBorderColor="red.300"
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              {!ePassword ? (
                ""
              ) : (
                <FormErrorMessage>
                  {wrong
                    ? "Les deux mots de passes ne correspondent pas"
                    : "wrong password"}
                  .
                </FormErrorMessage>
              )}
            </FormControl>

            <AlertDialogFooter>
              <Button bg="red" onClick={deleteCurrent} mr={3}>
                Delete
              </Button>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
}
